import { Email } from "@/Common/Api/Contacts/Dto/Email";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { SelectLookupControl } from "@/Common/Components/Inputs/SelectLookupControl";
import { TextboxMaskedControl } from "@/Common/Components/Inputs/TextboxMaskedControl";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";
import { ContactPointType } from "@/Common/Models/Contacts/Enums/ContactPointType";
import { SiteCreateState } from "../SiteCreate";

interface IEmailSectionProps {
    emails: Email[];
    emailsToRemove: string[];
    mutateState: (mutation: (state: SiteCreateState) => void, then?: () => void) => void;
}

function EmailSection(props: IEmailSectionProps): JSX.Element {
    const {
        emails,
        emailsToRemove,
        mutateState
    } = props;
    const validationHelper = new ValidationHelper();
    const emailValidationRule = validationHelper.getEmailValidationRule();
    const emailMask: string = emailValidationRule ? emailValidationRule.EditMaskPattern : "";
    const emailValidationErrorMessage: string = (emailValidationRule && emailValidationRule.ValidationErrorMessageLookupId) ? cacheStore.GetLocalizedValueByLookupId(emailValidationRule.ValidationErrorMessageLookupId) : "";

    function onAddEmail(): void {
        mutateState(s => {
            s.emails = emails;
            s.emails.push(Email.newEmail(ContactPointType.Work));
        });
    }

    function onRemoveEmail(idx: number): void {
        mutateState(s => {
            s.emails = emails;
            s.emailsToRemove = emailsToRemove;

            let emailToRemove = s.emails.splice(idx, 1);
            s.emailsToRemove.push(emailToRemove[0].ContactPoint_id);

            if (s.emails.length === 0) {
                s.emails.push(Email.newEmail(ContactPointType.Work));
            }
        });
    }

    function onChangeEmailType(idx: number, typeLookupId: string): void {
        mutateState(s => {
            s.emails = emails;
            let email = emails[idx];
            email.ContactPointTypeLookupId = typeLookupId;
            s.emails[idx] = email;
        });
    }

    function onChangeEmailAddress(idx: number, emailAddress: string): void {
        mutateState(s => {
            s.emails = emails;
            let email = emails[idx];

            email.Address = emailAddress;
            email.IsValid = Email.validateEmail(email.Address);

            s.emails[idx] = email;
        });
    }

    function onEmailIsPreferredChange(idx: number, isPreferred: boolean): void {
        mutateState(s => {
            s.emails = emails;
            let email = s.emails[idx];

            email.IsPreferred = isPreferred;

            s.emails.forEach(e => {
                if (e.renderId !== email.renderId) {
                    e.IsPreferred = false;
                }
            });
        });
    }

    return (
        <div>
            <div className="view-section-header">
                <h3 className="view-section-title">{cacheStore.GetString("EmailLabel")}</h3>
                <div className="text-right push-right-25">
                    <a onClick={() => onAddEmail()}>{cacheStore.GetString("AddLabel")}</a>
                </div>
            </div>
            {emails.map((x: Email, idx: number) => (
                <div className="view-section-body" key={"__e" + x.renderId}>
                    <div className="row" style={{ marginBottom: "15px" }}>
                        <div className="col-lg-4 col-md-3 col-sm-12 vcenter text-right">
                            <label className="form-label">{cacheStore.GetString("TypeLabel")}</label>
                        </div>
                        <div className="col-lg-5 col-md-9 col-sm-12">
                            <SelectLookupControl
                                IncludeEmptyChoice={false}
                                Value={x.ContactPointTypeLookupId}
                                AvailableValues={x.AvailableContactPointTypeLookupIds.map(x => x.ToComboboxItem())}
                                Callback={e => onChangeEmailType(idx, e)}
                                Item={x}
                            />
                        </div>
                        <span onClick={() => onRemoveEmail(idx)} style={{ color: "red", fontWeight: "bold", cursor: "pointer" }}>X</span>
                    </div>
                    <div className="row" style={{ marginBottom: "15px" }}>
                        <div className="col-lg-4 col-md-3 col-sm-12 vcenter text-right">
                            <label className="form-label">{cacheStore.GetString("AddressLabel")}</label>
                        </div>
                        <div className="col-lg-5 col-md-9 col-sm-12">
                            <TextboxMaskedControl
                                isValid={x.IsValid}
                                allowEmpty={true}
                                alphanumericIncludesPeriod={false}
                                returnMaskedValue={true}
                                id={"email" + x.renderId}
                                value={x.Address}
                                onChangeFunction={e => onChangeEmailAddress(idx, e)}
                                item={x}
                                mask={emailMask}
                                validationErrorMessage={emailValidationErrorMessage}
                                isEmail={true}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-3 col-sm-12 vcenter text-right" />
                        <div className="col-lg-5 col-md-9 col-sm-12">
                            <CheckboxControl
                                checked={x.IsPreferred}
                                label={cacheStore.GetString("PreferredEmailDLabel")}
                                onChange={e => onEmailIsPreferredChange(idx, e)}
                                item={x}
                            />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default EmailSection;
